import axios from "axios";
import React, { useEffect, useState } from "react";

const PostCard = ({ post }) => {
  const [company, setCompany] = useState({});
  
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await axios.post(
          "https://kariyer.biyomed.net/api/companies/getOneDetailsCard",
          { company_id: post.company_id },
          { withCredentials: true }
        );
        setCompany(response.data.company);
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    };

    if (post) {
      fetchCompany();
    }
  }, [post]);

  const formattedDate = new Date(post?.created_at).toLocaleDateString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const deletePost = async (e, postId) => {
    e.preventDefault();
    try {
      await axios.post("https://kariyer.biyomed.net/api/posts/delete-post", { id: postId });
      alert("İlan başarıyla silindi");
      window.location.href = "/myposts";
    } catch (err) {
      console.error("Error deleting post:", err.response.data.message);
    }
  };

  const resetApplicants = async (e, postId) => {
    e.preventDefault();
    try {
      await axios.put("https://kariyer.biyomed.net/api/posts/reset-applicants/", {
        post_id: postId,
      }, { withCredentials: true });
      window.location.href = `/applied-users/${postId}`;
    } catch (err) {
      console.error("Error resetting applicants:", err.response?.data?.message);
    }
  };

  return (
    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
      <div className="jp_job_post_main_wrapper_cont jp_job_post_grid_main_wrapper_cont">
        <div className="jp_job_post_main_wrapper jp_job_post_grid_main_wrapper">
          
          {/* Bildirim İkonu - Eğer başvuru varsa sağ üst köşede yanıp sönecek */}
          {post?.applicants > 0 && (
            <div style={{marginTop:30, marginRight:10}} className="notification-icon">
              <i className="fa fa-bell" />
            </div>
          )}

          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="jp_job_post_side_img">
                <img
                  src={company.profile_image ? company.profile_image : "https://pbs.twimg.com/profile_images/1305064450848960525/gsJVVM41_400x400.jpg"}
                  alt="post_img"
                  style={{ maxWidth: "90%", maxHeight: "300px", objectFit: "cover" }}
                />
              </div>
              <div className="jp_job_post_right_cont jp_job_post_grid_right_cont">
                <h4>
                  {post?.position_name.length > 30 ? post?.position_name.slice(0, 30) + "..." : post?.position_name}
                </h4>
                <p>{post?.company_name}</p>
                <ul>
                  <li>
                    <i className="fa fa-map-marker" />
                    &nbsp; {post?.city}
                  </li>
                  <li style={{ fontSize: "14px", marginTop: 3 }}>
                    <i className="fa fa-calendar" />
                    &nbsp; Oluşturma Tarihi: {formattedDate}
                  </li>
                  <li style={{ color: post?.job_status ? "green" : "red", fontWeight: "bold" }}>
                    {post?.job_status ? "İlan Yayında" : "İlan Pasif Durumda"}
                  </li>
                  <li style={{ color:"orange", fontWeight: "bold" }}>
                    {post?.applicants > 0 ? "Yenı Başvurular Mevcut" : ""}
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="jp_job_post_right_btn_wrapper jp_job_post_grid_right_btn_wrapper">
                <ul style={{ marginTop: 40 }}>
                  <li>
                    <a onClick={(e) => deletePost(e, post.id)} href="/">
                      <i className="fa fa-trash" /> Sil
                    </a>
                  </li>
                  <li>
                    <a style={{ marginLeft: 10 }} href={`/update-post/${post.id}`}>
                      DÜZENLE
                    </a>
                  </li>
                  <li>
                    <a href={`/applied-users/${post.id}`} onClick={(e) => resetApplicants(e, post.id)}>
                      BAŞVURANLARI GÖRÜNTÜLE
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="jp_job_post_keyword_wrapper">
          <ul>
            <li>
              <i className="fa fa-tags" /> Kategori :
            </li>
            <li>
              <a href="/">{post.position_category}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

// Bildirim İkonu İçin CSS
const styles = `
.notification-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: red;
  color: white;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  animation: blinking 2s infinite;
}

@keyframes blinking {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}
`;

// CSS kodlarını sayfaya ekleyelim
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default PostCard;
